"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Typescript does not support filter object keys with certain type yet
// Issue: https://github.com/Microsoft/TypeScript/issues/12424
// type Filter<T, U> = T extends U ? T : never
// type RelKey<T extends OMObject> = {
//     [_ in keyof T]: Filter<T[keyof T], number>
// }
class Included {
    constructor(ObjectType) {
        this.ObjectType = ObjectType;
    }
    from(keyPath) {
        return keyPath.join(",");
    }
}
exports.default = Included;
//# sourceMappingURL=Included.js.map